<div
  *ngIf="isSwitchedClient$ | async"
  class="e11-w-full e11-flex-shrink-0 e11-flex e11-items-center e11-justify-center e11-gap-4 e11-flex-wrap e11-px-4 e11-py-2 e11-bg-skin-primary/10 e11-text-skin-primary e11-border-b e11-border-skin-primary/30"
  role="status"
>
  <span class="e11-flex e11-items-center e11-gap-1 e11-font-primary-demibold">
    <span class="material-symbols-outlined e11-text-lg">swap_horiz</span>
    {{ 'Viewing client' | translate }} {{ clientLabel$ | async }}
  </span>

  <e11-button value="{{ 'Return to your account' | translate }}" color="primary" [disabled]="returning" (click)="return()"></e11-button>
</div>
